var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconEnvelope = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M21.75 4.5H2.25C1.836 4.5 1.5 4.836 1.5 5.25V18.5925C1.5 19.0065 1.836 19.3425 2.25 19.3425H21.75C22.164 19.3425 22.5 19.0065 22.5 18.5925V5.25C22.5 4.836 22.164 4.5 21.75 4.5ZM7.84125 11.9438L3 16.8248V7.06575L7.84125 11.943V11.9438ZM8.898 13.0087L11.4675 15.5978C11.7607 15.8933 12.2385 15.8933 12.5325 15.5978L15.1027 13.0087L19.896 17.8417H4.10475L8.898 13.0087ZM16.1588 11.9438L21 7.0665V16.8255L16.1588 11.9445V11.9438ZM19.9447 6L12 14.0048L4.05525 6H19.9455H19.9447Z", fill: "black" }))),
        alt: 'Icon Envelope',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconEnvelope;
//# sourceMappingURL=index.js.map